<template>
  <div>
    <vs-popup :title="$t('AttributeName')" :active.sync="editPopup">
      <form>
        <vs-input
          class="inputx mb-4 mt-1"
          v-model="attributeName"
          name="modalAttrName"
          :label="$t('Name')"
          v-validate="'required'"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('modalAttrName')"
          >{{ errors.first("modalAttrName") }}</span
        >
        <vs-button
          type="filled"
          class="float-right mb-4"
          @click.prevent="AttributeFormSubmit"
          >{{ $t("Save") }}</vs-button
        >
      </form>
    </vs-popup>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";
const dict = {
  custom: {
    modalAttrName: {
      required: "لطفا نام صفت را وارد نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  props: {
    show: { default: false },
    currentAttributeName: {
      default: null,
    },
  },
  data() {
    return {
      modal: {
        name: "",
      },
      attributeName: "",
    };
  },
  computed: {
    editPopup: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      createAttribute: "attribute/create",
    }),
    AttributeFormSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.model = {
            name: this.attributeName,
          };
          this.createAttribute(this.model).then(() => {
            this.$swal({
              position: "center-center",
              type: "success",
              text: "رکورد مورد‌نظر با موفقیت ویرایش شد!",
              showConfirmButton: false,
              timer: 2000,
            });
            this.$emit("finish");
            this.attributeName = "";
            this.model = {};
            this.$validator.reset();
          });
        } else {
          // form have errors
        }
      });
    },
  },
  watch: {
    show() {
      if (this.show) {
        if (this.currentAttributeName) {
          this.attributeName = this.currentAttributeName;
        }
      }
    },
  },
};
</script>
